import Form from 'react-bootstrap/Form';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';
import { useUpdateTag } from 'app/api/tag-queries';

interface HiddenSwitchProps {
  tagId: string;
  documentSuperId: number;
  currentHiddenValue: boolean;
  snapshotValue: string;
  isPlaced: boolean;
  disabled?: boolean;
}

export const HiddenSwitch = ({ tagId, documentSuperId, currentHiddenValue, snapshotValue, isPlaced, disabled = false }: HiddenSwitchProps) => {
  const { mutate: updateTag } = useUpdateTag();

  const handleUpdate = (hidden: boolean) => {
    if (hidden) {
      updateTag({ id: tagId, documentSuperId, hidden: true, value: snapshotValue });
    } else {
      updateTag({ id: tagId, documentSuperId, hidden: false });
    }
  };

  const lockedUnplaced = currentHiddenValue && !isPlaced;

  return (
    <div className="property-row">
      <Typography fontWeight="semibold" className="property-label">
        {i18n('tag.hidden.title')}
      </Typography>
      <Form.Check
        type="switch"
        id={`hidden-switch-${tagId}`}
        checked={currentHiddenValue}
        onChange={(e) => handleUpdate(e.target.checked)}
        disabled={disabled || lockedUnplaced}
        style={disabled || lockedUnplaced ? { cursor: 'not-allowed' } : undefined}
      />
    </div>
  );
};
